angular.module('homebot.services')

.service('SessionService', ['$cookies', function($cookies){
  let service = {
    getAuthHeader(){
      let token = service.getLockboxToken();

      if(token)
        return `Bearer ${token}`;

      let nodeToken = service.getNodeToken();

      if(nodeToken)
        return nodeToken;

      let homeownerToken = service.getHomeownerToken();

      if(homeownerToken)
        return homeownerToken;

      return null;
    },

    extractJWT() {
      try {
        const jwt = service.getLockboxToken();
        return JSON.parse(atob(jwt.split('.')[1]));
      } catch(e) {
        return null;
      }
    },

    isParagonUser(){
      let jwt = service.extractJWT();
      const matchParagon = /^sso:paragon(:){0,1}/;
      const matchLegacyParagon = /^sso:pgnimp(:){0,1}/;

      return jwt && (
        matchParagon.test(jwt.kind) || matchLegacyParagon.test(jwt.kind)
      );
    },

    isAgent(){
      if(service.getLockboxToken() || service.getNodeToken())
        return true;

      return false;
    },

    isImpersonating(){
      const jwt = service.extractJWT();
      return jwt && jwt.kind === 'homebot:imp';
    },

    getLockboxCookie(){
      return $cookies.getObject('homebot-session-cookie');
    },

    getLockboxToken(){
      let cookie = service.getLockboxCookie();

      if(cookie && cookie.authenticated && cookie.authenticated.access_token)
        return cookie.authenticated.access_token;

      return null;
    },

    getNodeToken(){
      let agentCookie = $cookies.getObject('agent');

      return agentCookie ? agentCookie.access_token : null;
    },

    getHomeownerToken(){
      return $cookies.get('accessToken') || null;
    },

    isLoggedIn(){
      return Boolean(service.getLockboxToken() || service.getNodeToken());
    },

    clear(){
      // TODO : clear intercom
      $cookies.putObject('agent',null,{path:'/'});
      $cookies.remove('agent',{path:'/'});
      return Promise.resolve()
    },

  };

  return service;
}]);
